import { Component, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {MatDialog as MatDialog } from "@angular/material/dialog";
import {MatPaginator as MatPaginator, PageEvent as PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {MatTableDataSource as MatTableDataSource } from "@angular/material/table";
import { RolesDialogeComponent } from "../roles-dialoge/roles-dialoge.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-blogs-articles",
  templateUrl: "./blogs-articles.component.html",
  styleUrls: ["./blogs-articles.component.css"],
})
export class BlogsArticlesComponent implements OnInit {
  displayedColumns: string[] = [
    "Id",
    "Title",
    "CreationDate",
    "PublishDate",
    "ExpiryDate",
    "Category",
    "Actions",
  ];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  post: any = {};
  categories: any[] = [];

  posts: any[] = [];
  totalLength: any[] = [];

  filterForm: any = {
    searchValue: "",
    categoriesIds: [],
    pageSize: 10,
    pageNo: 0,
    postsSort: null,
  };

  constructor(
    private httpClient: HttpClient,
    public dialog: MatDialog,
    private snotifyService: ToastrService,
  ) {
    
  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.sort = this.sort;
    this.GetAllCategories();

    // get LAST saved filter
    const searchQuery = sessionStorage.getItem("blogArticlesSearchQuery");
    if (searchQuery) {
      this.filterForm = JSON.parse(searchQuery);
      sessionStorage.removeItem("blogArticlesSearchQuery");
      this.paginator.pageIndex = this.filterForm.pageNo;
      this.paginator.pageSize = this.filterForm.pageSize;
    }
    // get LAST saved filter

    //this.dataSource.paginator = this.paginator;

    this.getPosts();
  }

  public sortBlogs(event) {
    this.filterForm.postsSort = {
      SortField: event.active,
      SortType: event.direction ? event.direction : "asc",
    };
    this.getPosts();
  }

  public getPosts() {
    // save LAST saved filter
    sessionStorage.setItem(
      "blogArticlesSearchQuery",
      JSON.stringify(this.filterForm)
    );
    if (this.filterForm.postsSort) {
      if (
        this.filterForm.postsSort.SortField &&
        !this.filterForm.postsSort.SortType
      ) {
        this.filterForm.postsSort = null;
      }
    }
    this.httpClient
      .post(`/BolgArchive/GetPostsForAdmin`, this.filterForm)
      .subscribe((res: any) => {
        this.posts = res.list;
        this.totalLength = res.totalCount;
        this.dataSource = new MatTableDataSource<any>(res.list);
      });
  }

  public changePage(event: PageEvent) {
    this.filterForm.pageNo = event.pageIndex;
    this.filterForm.pageSize = event.pageSize;
    this.getPosts();
  }

  GetAllCategories() {
    this.httpClient
      .get("/Categories/GetCategoriesByTypeId/7")
      .subscribe((res: any) => {
        this.categories = res ? res : [];
      });
  }

  removePost(Post) {
    this.httpClient
      .get(`/BolgArchive/UpdateStatusPosts/${Post.id}/3`)
      .subscribe((res: any) => {
        this.getPosts();
        this.openNotifySuccess("Post Deleted");
      });
  }

  DuplicatePost(Post) {
    this.httpClient
      .post("/BolgArchive/DuplicatePost/" + Post.id, {})
      .subscribe((res: any) => {
        this.openNotifySuccess("Post Duplicated");
        this.getPosts();
      });
  }

  securityDialog(element) {
    this.httpClient
      .get(`/BolgArchive/GetPostAssignedRoles/${element.id}`)
      .subscribe((res: any) => {
        let dialogRef = this.dialog.open(RolesDialogeComponent, {
          width: "70vw",
          data: {
            unAssigendRole: res.unassingedRoles,
            assigendRoles: res.assingedRoles,
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            let rolesAndAsigend: any = {
              id: element.id,
              unassingedRoles: result.unAssigendRole,
              assingedRoles: result.assigendRoles,
            };
            this.httpClient
              .post("/BolgArchive/SavePostAssginedRoles", rolesAndAsigend)
              .subscribe(
                (res: any) => {
                  this.snotifyService.success("", "Assigend Successfully", {
                    timeOut: 2000,
                    progressBar: true,
                    tapToDismiss: true,
                  });
                });
          }
        });
      });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
}
